<template>
  <div>
    <SpinnerIcon class="h-full w-full animate-spin" />
  </div>
</template>

<script>
import SpinnerIcon from '@/components/icons/SpinnerIcon';

export default defineNuxtComponent({
  components: { SpinnerIcon },
});
</script>
